function domainFilter($window) {
    return function (url) {
        return url.split('www.portfolium.com').join($window.location.host);
    };
}

domainFilter.$inject = ['$window'];

export default domainFilter;
